export async function deletarDispositivo(idDispositivo) {
  const url = `${process.env.REACT_APP_MICROSERVICO_IP}/cmd/devices/${idDispositivo}`;

  try {
    const response = await fetch(url, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      const errorData = await response.text();
      throw new Error(`Erro na resposta: ${response.status} - ${errorData}`);
    }

    let responseData;
    try {
      responseData = await response.json();
    } catch (err) {
      responseData = null;
    }

    console.log('Resposta do servidor:', responseData);
    return responseData;

  } catch (error) {
    console.error('Erro ao deletar dispositivo:', error);
    throw error;
  }
}
